import WebSocket from 'ws';
import { sendWsMessage } from '../connection/create-ws-bridge.js';
import { getBridgeRoot } from './cwd/index.js';
import { ensureFileIndexAsync, bridgeFileIndexIsPopulated, searchBridgeFilePathsAsync } from './index/index.js';
import { yieldToEventLoop } from '../runtime/yield-to-event-loop.js';
import { resolveFileBrowserSessionParent } from './resolve-file-browser-session-parent.js';
import type { SessionWorktreeManager } from '../worktrees/manager.js';
import type { CliE2eeRuntime } from '../lib/e2ee/index.js';
import path from 'node:path';

export interface FileBrowserSearchMessage {
  id: string;
  type: 'file_browser_search';
  q: string;
  sessionId?: string;
}

const SEARCH_LIMIT = 100;

export function handleFileBrowserSearch(
  msg: FileBrowserSearchMessage,
  socket: WebSocket,
  e2ee?: CliE2eeRuntime,
  sessionWorktreeManager?: SessionWorktreeManager,
): void {
  void (async () => {
    await yieldToEventLoop();
    const q = typeof msg.q === 'string' ? msg.q : '';
    const sessionParentPath = path.resolve(
      sessionWorktreeManager != null
        ? await resolveFileBrowserSessionParent(sessionWorktreeManager, msg.sessionId)
        : getBridgeRoot(),
    );
    if (!(await bridgeFileIndexIsPopulated(sessionParentPath))) {
      triggerFileIndexBuild(sessionParentPath);
      const payload = {
        type: 'file_browser_search_response',
        id: msg.id,
        paths: [],
        indexReady: false,
      };
      sendWsMessage(socket, e2ee ? e2ee.encryptFields(payload, ['paths']) : payload);
      return;
    }
    const results = await searchBridgeFilePathsAsync(sessionParentPath, q, SEARCH_LIMIT);
    const payload = {
      type: 'file_browser_search_response',
      id: msg.id,
      paths: results,
      indexReady: true,
    };
    sendWsMessage(socket, e2ee ? e2ee.encryptFields(payload, ['paths']) : payload);
  })();
}

/** Kick off index build in background so future search can use it. */
export function triggerFileIndexBuild(sessionParentPath: string = getBridgeRoot()): void {
  setImmediate(() => {
    void ensureFileIndexAsync(sessionParentPath).catch((e) => {
      console.error('[file-index] Background build failed:', e);
    });
  });
}
